const ErrorText = ({ text }: { text: string }) => {
  return <div className="text-small text-error mt-2">{text}</div>;
};

export default ErrorText;
